"use client";

import React from 'react';

interface QuickConfirmAssignData {
    shiftId: string;
    day: Date;
    employeeId: string;
}

interface QuickConfirmAssignModalProps {
    onClose: () => void;
    onConfirm: () => void;
    data: QuickConfirmAssignData;
}

const QuickConfirmAssignModal: React.FC<QuickConfirmAssignModalProps> = ({ onClose, onConfirm, data }) => {
    return (
        <div className="fixed inset-0 z-[100] bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm mx-4 transform transition-all">
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-lg font-bold text-blue-700">PHÂN CÔNG CA LÀM VIỆC</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <span className="text-xl">×</span>
                    </button>
                </div>

                {/* Body (Nội dung Xác nhận) */}
                <div className="p-6 text-center">
                    <div className="text-green-500 mx-auto mb-4">
                        <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                    </div>
                    
                    <p className="text-gray-700 mb-4">
                        Bạn có chắc chắn muốn phân công công việc này cho nhân viên?
                    </p>
                </div>

                <div className="p-4 border-t flex justify-end">
                    <button
                        onClick={onConfirm}
                        className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md 
                                   hover:bg-blue-700 transition duration-150"
                    >
                        XÁC NHẬN
                    </button>
                </div>
            </div>
        </div>
    );
};

export default React.memo(QuickConfirmAssignModal);